export const ObjectStatusCssClasses = ["success", "danger"];
export const ObjectGenderTitles = [
  "MODULES.BASEINFO.USERS.GENDER_MALE",
  "MODULES.BASEINFO.USERS.GENDER_FEMALE",
];
export const ObjectEmsTitles = [
  "MODULES.BASEINFO.EMS.SETTING.TYPE1",
  "MODULES.BASEINFO.EMS.SETTING.TYPE2",
];

export const ObjectChangePasswordTitles = [
  "MODULES.GENERAL.NEED_PASSWORD_CHANGE_FALSE",
  "MODULES.GENERAL.NEED_PASSWORD_CHANGE_TRUE",
];
export const ObjectDeletedTitles = [
  "MODULES.GENERAL.STATUSNONDELETED",
  "MODULES.GENERAL.STATUSDELETED",
];
export const ObjectStatusTitles = [
  // "MODULES.GENERAL.STATUSENABLE",
  "MODULES.GENERAL.STATUSNONDELETED",
  "MODULES.GENERAL.STATUSDELETED",
];
export const ObjectActiveTitles = [
  "MODULES.GENERAL.STATUSENABLE",
  "MODULES.GENERAL.STATUSDISABLE",
];
export const ObjectPayTitles = [
  "MODULES.GENERAL.PAID",
  "MODULES.GENERAL.UNPAID",
];
export const ObjectConfirmCssClasses = ["danger", "info"];
export const ObjectConfirmTitles = [
  "MODULES.GENERAL.REJECTED",
  "MODULES.GENERAL.CONFIRMED",
];

export const ObjectConfirmRoomReservationTitles = [
  "MODULES.GENERAL.REJECTED",
  "MODULES.ROOM.RESERVATION.CONFIRMED",
];

export const ObjectReserveStatusTitles = [
  "MODULES.GENERAL.REJECTED",
  "MODULES.GENERAL.NEEDPAY",
];
export const ObjectConditionCssClasses = ["success", "danger", ""];
export const ObjectConditionTitles = ["New", "Used"];
export const defaultSorted = [{ dataField: "id", order: "desc" }];
export const sizePerPageList = [
  { text: "10", value: 10 },
  { text: "20", value: 20 },
  // { text: "30", value: 30 },
  // { text: "40", value: 40 },
  { text: "50", value: 50 },
  { text: "100", value: 100 }
];


export const ObjectSubSystemTitles = [
  "ASID.TABS.NONE",
  "ASID.TABS.BASEINFO",
  "ASID.TABS.ATTENDANCE",
  "ASID.TABS.CULLINAN",
  "ASID.TABS.DORMITORY",
  "ASID.TABS.SPORT",
];
export const ObjectSubSystemCssClasses = ["none", "warning", "info", "success", "danger", "warning"];

export const ObjectRankingParameterTypeTitles = [
  "RANKINGSETTING.PARAMETERTYPE.NONE",
  "RANKINGSETTING.PARAMETERTYPE.GRADE",
  "RANKINGSETTING.PARAMETERTYPE.FATHERJOB",
  "RANKINGSETTING.PARAMETERTYPE.SUPPORTINGINSTITUE",
  "RANKINGSETTING.PARAMETERTYPE.SPECIALCONDITION",
  "RANKINGSETTING.PARAMETERTYPE.DISTANCE",
  "RANKINGSETTING.PARAMETERTYPE.MARTYRORVETERANS",
  "RANKINGSETTING.PARAMETERTYPE.OTHER",
  "RANKINGSETTING.PARAMETERTYPE.MILITARY",
  "RANKINGSETTING.PARAMETERTYPE.CHILDSCOUNT",
];

export const ObjectWeekDayTitles = [
  "---",
  "یکشنبه",
  "دوشنبه",
  "سه شنبه",
  "چهارشنبه",
  "پنجشنبه",
  "جمعه",
  "شنبه",
];

export const ObjectRankingParameterTypeCssClasses = ["default", "warning", "info", "success", "megna", "info", "danger", "primary", "warning"];

export const SubSystemTypeEnum = // Table enum
{
  None: 0,
  Base: 1,
  Attendance: 2,
  Dorm: 3,
  Sport: 4,
  Food: 5,
};

export const ObjectPriorityCssClasses = ["none", "warning", "info", "success", "danger"];
export const PriorityTypeEnum = // Table enum
{
  None: 0,
  Low: 1,
  Medium: 2,
  High: 3,
  Urgent: 4,
};
export const ObjectPriorityTitles = [
  "MODULES.PRIORITY.NONE",
  "MODULES.PRIORITY.LOW",
  "MODULES.PRIORITY.MEDIUM",
  "MODULES.PRIORITY.HIGH",
  "MODULES.PRIORITY.URGENT"
];

export const ObjectRegisterStatusCssClasses = ["none", "dark", "warning", "danger", "info", "success"];

export const ObjectRegisterStatusTitles = [
  "REGISTER.STATUS.NONE",
  "REGISTER.STATUS.INCOMPLETE",
  "REGISTER.STATUS.EXPIRED",
  "REGISTER.STATUS.REJECTED",
  "REGISTER.STATUS.CHECKING",
  "REGISTER.STATUS.APPROVED",
];


export const ObjectCorrespondenceStatusCssClasses = ["none", "warning", "info", "success", "danger", "info", "success", "danger"];
export const CorrespondenceStatusTypeEnum = // Table enum
{
  None: 0,
  UnRead: 1,
  Readed: 2,
  Answered: 3,
  InProgress: 4,
  Waiting: 5,
  Referred: 6,
  Archived: 7,
};
export const ObjectCorrespondenceStatusTitles = [
  "CORRESPONDENCE.STATUS.NONE",
  "CORRESPONDENCE.STATUS.UNREAD",
  "CORRESPONDENCE.STATUS.READED",
  "CORRESPONDENCE.STATUS.ANSWERED",
  "CORRESPONDENCE.STATUS.INPROGRESS",
  "CORRESPONDENCE.STATUS.WAITING",
  "CORRESPONDENCE.STATUS.REFERRED",
  "CORRESPONDENCE.STATUS.ARCHIVED"
];

export const ObjectNeedConfirmCssClasses = ["success", "danger"];
export const ObjectNeedConfirmTitles = [
  "MODULES.DORM.TIMESETTING.NEED_CONFIRM.TRUE",
  "MODULES.DORM.TIMESETTING.NEED_CONFIRM.FALSE",
];
